import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useWebData } from "../../Context/webDataContext";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import parse from "html-react-parser";

function PolicyPage() {
  const { policyName } = useParams();
  const { getPoliciesData } = useWebData();
  const policies = getPoliciesData();
  const policy = policies.find((p) => p.path === policyName);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [policyName]);

  if (!policy) {
    return (
      <>
        <Navbar />
        <div className="w-full h-screen flex items-center justify-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Policy not found
          </h1>
          <p className="text-lg text-gray-600">
            The policy you are looking for does not exist or has been removed.
          </p>
          <p className="text-lg text-gray-600">
            Please check the URL or return to the homepage.
          </p>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <section className="w-full px-4 lg:container mx-auto text-left mt-24 md:mt-12">
        {/* Policy Title */}
        <h1 className="manrope text-2xl md:text-4xl font-semibold text-gray-900 mb-4">
          {policy.title}
        </h1>

        {/* Effective Date */}
        {policy.effectiveDate && (
          <p className="text-base md:text-lg text-gray-600 md:mb-5">
            Effective Date: {policy.effectiveDate}
          </p>
        )}

        {/* Main Content */}
        <div className="mb-8">
          <div className="text-base md:text-lg text-gray-600">
            {parse(policy.content)}
          </div>
          <div className="text-gray-700 text-lg leading-relaxed"></div>
        </div>

        {/* Sections */}
        {policy.sections && policy.sections.length > 0 && (
          <div className="space-y-8">
            {policy.sections.map((section, index) => (
              <div key={index} className="lg:mb-8 mb-5">
                <div className="flex items-center gap-3 mb-3">
                  {/* Section Number */}
                  {/* Section Header */}
                  <h2 className="text-xl md:text-2xl font-semibold text-gray-900">
                    {parse(section.header)}
                  </h2>
                </div>
                {/* Section Content */}
                <div
                  className="text-base md:text-lg text-gray-600 pl-4" // Added padding to align with header
                >
                  {parse(section.content)}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Footer Note */}
        <div className=" mb-16 text-sm text-gray-500">
          <p>
            If you have any questions about this policy, please contact us at{" "}
            <a
              href="mailto:maideazesolutions@gmail.com"
              className="text-blue-600 hover:underline"
            >
              maideazesolutions@gmail.com
            </a>
          </p>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default PolicyPage;
